"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _algoliasearch = _interopRequireDefault(require("algoliasearch"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var Algolia = /*#__PURE__*/_createClass(function Algolia(algolia) {
  var _this = this;
  _classCallCheck(this, Algolia);
  this.algoliaQuestionSearch = function (keyword, questionBankId, subjectIds) {
    var algoliaClient = (0, _algoliasearch.default)(_this.algolia.appId, _this.algolia.apiKey);
    var searchIndex = algoliaClient.initIndex('Question');

    // Minimum search term length is 3 characters
    if (keyword.length < 3) return null;
    var hits = [];
    return searchIndex.browseObjects({
      query: keyword,
      numericFilters: "qbank_ids = ".concat(questionBankId),
      facetFilters: [subjectIds.map(function (id) {
        return "subject_ids:" + id;
      })],
      attributesToRetrieve: ['objectID'],
      batch: function batch(_batch) {
        hits = hits.concat(_batch);
      }
    }).then(function () {
      return new Set(hits.map(function (hit) {
        return parseInt(hit.objectID);
      }));
    });
  };
  this.algoliaProductsSearch = function (keyword) {
    var algoliaClient = (0, _algoliasearch.default)(_this.algolia.appId, _this.algolia.apiKey);
    var searchIndex = algoliaClient.initIndex('ProductPage');

    // Minimum search term length is 3 characters
    if (keyword.length < 3) return null;
    return searchIndex.search(keyword, {
      hitsPerPage: 7
    });
  };
  this.algoliaClinicalPearlSearch = function (keyword, questionBankId, categoryIds) {
    var algoliaClient = (0, _algoliasearch.default)(_this.algolia.appId, _this.algolia.apiKey);
    var searchIndex = algoliaClient.initIndex('ClinicalPearl');

    // Minimum search term length is 3 characters
    if (keyword.length < 3) return null;
    var hits = [];
    return searchIndex.browseObjects({
      query: keyword,
      numericFilters: "qbank_ids = ".concat(questionBankId),
      facetFilters: [categoryIds.map(function (id) {
        return "category_ids:" + id;
      })],
      attributesToRetrieve: ['objectID'],
      batch: function batch(_batch2) {
        hits = hits.concat(_batch2);
      }
    }).then(function () {
      return new Set(hits.map(function (hit) {
        return parseInt(hit.objectID);
      }));
    });
  };
  this.algolia = algolia;
});
;
var _default = exports.default = Algolia;